module.exports = __webpack_public_path__ + "img/32.30da1edf.gif";